var map = {
	"./3d-rotation.svg": "1684",
	"./3d.svg": "3491",
	"./approval.svg": "e96a",
	"./arrow-left.svg": "ac3b",
	"./arrow-right-square-fill.svg": "9cac",
	"./automated.svg": "d62b",
	"./bag.svg": "47fd",
	"./barcode.svg": "b632",
	"./battery-low.svg": "2f26",
	"./blob.svg": "8742",
	"./blocked.svg": "fc64",
	"./box-seam.svg": "30b7",
	"./box.svg": "bb19",
	"./bullet.svg": "5255",
	"./caffe.svg": "9d2c",
	"./calendario.svg": "3668",
	"./caret-down-dark.svg": "aee7",
	"./caret-down.svg": "3f24",
	"./caret-up-dark.svg": "54ba",
	"./caret-up.svg": "2d60",
	"./change-test.svg": "f16e",
	"./characterization/dente-inf.svg": "6896",
	"./characterization/dente-med.svg": "a339",
	"./characterization/dente-sup.svg": "5e6a",
	"./chat/caret-down.svg": "6014",
	"./chat/caret-up.svg": "3e2b",
	"./chat/chat.svg": "9744",
	"./chat/qr-code.svg": "f3b5",
	"./check-circle-fill-green.svg": "514c",
	"./check-circle-fill-violet.svg": "ad2e",
	"./check-circle-green.svg": "d370",
	"./check-circle.svg": "cfcb",
	"./check-white.svg": "5131",
	"./check.svg": "7bae",
	"./checkbox-checked-violet.svg": "820d",
	"./checkbox-checked.svg": "7f87",
	"./checkbox.svg": "5b02",
	"./chevron-down.svg": "1755",
	"./chevron-left-violet.svg": "0f6e",
	"./chevron-up.svg": "bb5d",
	"./clock-black.svg": "3498",
	"./clock.svg": "755b",
	"./close-circle-fill-red.svg": "9d55",
	"./close-circle-fill.svg": "b329",
	"./close-circle-red.svg": "747f",
	"./close-circle-white.svg": "9b99",
	"./close-circle.svg": "1cfc",
	"./close-white.svg": "72e4",
	"./close.svg": "8b1b",
	"./consulting/pause.svg": "f3e6",
	"./consulting/pending-violet.svg": "ea09",
	"./consulting/question.svg": "fbd5",
	"./copy.svg": "8aac",
	"./danger.svg": "f6f2",
	"./dash.svg": "bfba",
	"./dente inf-04.svg": "29b5",
	"./dente med-03.svg": "a906",
	"./dente sup-02.svg": "4d1e",
	"./dente_16.svg": "8337",
	"./dente_17.svg": "252a",
	"./dente_18.svg": "5621",
	"./department.svg": "d95e",
	"./digital-label.svg": "7bee",
	"./dislike-red.svg": "1dc7",
	"./dislike-white.svg": "0595",
	"./dislike-yellow.svg": "1d67",
	"./dislike.svg": "a2a2",
	"./dottore.svg": "0c40",
	"./download-cloud.svg": "de7d",
	"./download.svg": "f28e",
	"./edit.svg": "daf0",
	"./external-link-violet.svg": "d57c",
	"./filter.svg": "2376",
	"./flag.svg": "c26e",
	"./furgone.svg": "00f5c",
	"./gear-violet.svg": "ca5d",
	"./geo-alt.svg": "bc00",
	"./grip-vertical.svg": "01b2",
	"./heart-selected.svg": "3364",
	"./heart.svg": "7d16",
	"./history.svg": "14e1",
	"./iso-in/accept.svg": "cf37",
	"./iso-in/changed-test.svg": "ca79",
	"./iso-in/custom.svg": "74b5",
	"./iso-in/fork-right.svg": "a773",
	"./iso-in/reassign.svg": "e6e3",
	"./iso-in/refuses.svg": "8034",
	"./iso-in/suspend.svg": "f920",
	"./jump-link.svg": "8398",
	"./lavorazione.svg": "7dbf",
	"./like-green.svg": "28d8",
	"./like.svg": "6d8b",
	"./link-to.svg": "114e",
	"./logistic-checkin/3d-rotation.svg": "39e2",
	"./logistic-checkin/calendar.svg": "4fff",
	"./logistic-checkin/customer.svg": "3572",
	"./logistic-checkin/dental-chair.svg": "53a4",
	"./logistic-checkin/doctor.svg": "5641",
	"./logistic-checkin/gem.svg": "30fe",
	"./logistic-checkin/keyboard.svg": "eec4",
	"./logistic-checkin/scanner-barcode.svg": "c82a",
	"./logistic-checkin/van.svg": "5016",
	"./logistic-checkin/vertical-dots.svg": "e224",
	"./logistic-checkin/wrench.svg": "0720",
	"./logout.svg": "69e3",
	"./manager/bell.svg": "b119",
	"./manager/change-test.svg": "e176",
	"./manager/chevron-left.svg": "e894",
	"./manager/chevron-right.svg": "728d",
	"./manager/chevron-rigth-violet.svg": "6614",
	"./manager/circle-selected.svg": "22df",
	"./manager/circle.svg": "91e5",
	"./manager/faild.svg": "c0ff",
	"./manager/forward-clinic.svg": "353d",
	"./manager/gears.svg": "e227",
	"./manager/reassign.svg": "7b12",
	"./manager/resume.svg": "1629",
	"./manager/sent-mail.svg": "af7c",
	"./media/check-circle.svg": "24a8",
	"./media/close-circle.svg": "8c52",
	"./media/pause.svg": "cdac",
	"./media/play.svg": "97d4",
	"./media/stop.svg": "6c82",
	"./mobile/chat.svg": "5e7f",
	"./mobile/details.svg": "4b36",
	"./mobile/home.svg": "bc57",
	"./mobile/orders.svg": "949b",
	"./mobile/projects.svg": "c1bf",
	"./model/arch/arch-inf-sel.svg": "c5ac",
	"./model/arch/arch-inf.svg": "2e83",
	"./model/arch/arch-sup-sel.svg": "ff95",
	"./model/arch/arch-sup.svg": "32c6",
	"./model/checkbox.svg": "919c",
	"./model/custom-pin/custom-pin-sel.svg": "74d1b",
	"./model/custom-pin/custom-pin.svg": "8b95",
	"./model/gum/gum-plus.svg": "b1c6",
	"./model/gum/gum-sel.svg": "0e03",
	"./model/gum/gum.svg": "39d7",
	"./model/milling/milling-sel.svg": "9bcd",
	"./model/stump/stump-plus.svg": "ed38",
	"./model/stump/stump-sel.svg": "69b7",
	"./model/stump/stump.svg": "b286",
	"./more-info.svg": "4d73",
	"./move-up.svg": "5272",
	"./note.svg": "f079",
	"./pause.svg": "644b",
	"./paziente.svg": "93d8",
	"./pencil.svg": "e51f",
	"./pending.svg": "e25a",
	"./play-outline-green.svg": "8b3f",
	"./play-outline-white.svg": "2ee3",
	"./play-outline.svg": "4e65",
	"./play.svg": "dab1",
	"./playlist-add.svg": "5fc5",
	"./plus-circle-fill.svg": "32f4",
	"./plus-violet.svg": "d798",
	"./plus-white.svg": "7e53",
	"./poltrona_dentista.svg": "b18f",
	"./prescription.svg": "844d",
	"./printer-black.svg": "3e18",
	"./printer-white.svg": "9fc4",
	"./printer.svg": "345d",
	"./project/arch/arch-inf-sel.svg": "718b",
	"./project/arch/arch-inf.svg": "5ed2",
	"./project/arch/arch-sup-sel.svg": "3e1f",
	"./project/arch/arch-sup.svg": "afc6",
	"./project/bridge/bridge-sel.svg": "41e7",
	"./project/bridge/bridge.svg": "29ef",
	"./project/emiarch/emiarch-1-sel.svg": "71c5",
	"./project/emiarch/emiarch-1.svg": "aba8",
	"./project/emiarch/emiarch-2-sel.svg": "2eaf",
	"./project/emiarch/emiarch-2.svg": "8d2b",
	"./project/emiarch/emiarch-3-sel.svg": "f731",
	"./project/emiarch/emiarch-3.svg": "7c1e",
	"./project/emiarch/emiarch-4-sel.svg": "6e7e",
	"./project/emiarch/emiarch-4.svg": "9b4a",
	"./project/mouth/mouth-sel.svg": "8ed2",
	"./project/mouth/mouth.svg": "128f",
	"./project/sest/sest-1-sel.svg": "2186",
	"./project/sest/sest-1.svg": "ccbf",
	"./project/sest/sest-2-sel.svg": "da91",
	"./project/sest/sest-2.svg": "cc41",
	"./project/sest/sest-3-sel.svg": "7014",
	"./project/sest/sest-3.svg": "c3e8",
	"./project/sest/sest-4-sel.svg": "9262",
	"./project/sest/sest-4.svg": "13ab",
	"./project/sest/sest-5-sel.svg": "ad52",
	"./project/sest/sest-5.svg": "9c00",
	"./project/sest/sest-6-sel.svg": "71a0",
	"./project/sest/sest-6.svg": "342e0",
	"./puntini.svg": "a7c7",
	"./save-outline-violet.svg": "3e8c",
	"./scan-done.svg": "9472",
	"./scan.svg": "a4c5",
	"./search-violet.svg": "c18f",
	"./search-white.svg": "1d41",
	"./search.svg": "d103",
	"./shipping-code.svg": "f31a",
	"./shopping-cart-add.svg": "a93c",
	"./shopping-cart.svg": "b15e",
	"./situ/scan-3d.svg": "24b7",
	"./sospendi.svg": "b59e",
	"./special/exclamation-circle.svg": "e99c",
	"./special/question.svg": "01f9",
	"./switch-user.svg": "8eb6",
	"./sync.svg": "9c0e",
	"./tecnico.svg": "c9a6",
	"./telegram-violet.svg": "ec48",
	"./telegram-white.svg": "3d46",
	"./termina.svg": "ab43",
	"./trash-violet.svg": "b21a",
	"./upload-video.svg": "a93a",
	"./upload-violet.svg": "64da",
	"./upload.svg": "5a96",
	"./user.svg": "6aed",
	"./van.svg": "78d4",
	"./view-list.svg": "641c",
	"./waiting-for-approval.svg": "5d5d",
	"./warehouse.svg": "e53c",
	"./warning.svg": "daa9",
	"./x-circle-fill-violet.svg": "bf6e"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "67f7";